// src/app/audit/AI/CoPilotV2/components/Error.js
import React from 'react';
import styled from 'styled-components';

const Error = ({ message, onDismiss }) => {
  if (!message) return null;

  return (
    <ErrorContainer>
      <ErrorMessage>
        {message}
      </ErrorMessage>
      {onDismiss && (
        <DismissButton onClick={onDismiss}>
          ×
        </DismissButton>
      )}
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background-color: #fee2e2;
  border: 1px solid #fecaca;
  color: #dc2626;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const ErrorMessage = styled.span`
  font-size: 14px;
`;

const DismissButton = styled.button`
  background: none;
  border: none;
  color: #dc2626;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
`;

export default Error;